<div *ngIf="showPopup" class="modal fade" tabindex="-1" role="dialog" [config]="{show:true,backdrop:'static'}" bsModal
    #autoShowModal="bs-modal">
    <div class="custom-theme-modal modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body pt-0">
                <div class="row">
                    <div class="col-12 text-center mt-4">
                        <img [src]="banner" alt="banner">
                        <p class="heading-4 mt-2">{{heading}}</p>
                        <p class="secondary-paragraph color-grey-700">{{paragraph}}</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer px-3 text-center pt-2 pb-4 justify-content-center">
                <button *ngIf="showCancelButton" class="btn-design outline medium px-4"
                    (click)="modalActionFunction(false)">{{cancelText}}</button>
                <button *ngIf="showSubmitButton" class="btn-design filled medium px-4"
                    (click)="modalActionFunction(true)">{{submitText}}</button>
            </div>
        </div>
    </div>
</div>